import { render, staticRenderFns } from "./login2.vue?vue&type=template&id=5e2cae3a&"
import script from "./login2.vue?vue&type=script&lang=js&"
export * from "./login2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports